import {
  AfterViewInit,
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnChanges,
  OnDestroy,
  OnInit,
  Output,
  Renderer2,
  ViewChild,
} from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { TranslateService } from '../../core/translation';
import { Utils } from '../../shared/utils/utils';
import { MatDialog } from '@angular/material/dialog';
import { FilesUploadDialogComponent } from './dialog/files-upload-dialog/files-upload-dialog.component';
import { MessageService } from '../../shared/message/message.service';
import { SizeAllDocsService } from '../../base/services/sizeAllDocs/sizeAllDocs.service';
import { FilesUploadService } from './services/files-upload-service/files-upload.service';
import { FileUploadType } from '../../models/files-upload';
import { FilesUploadChangeEvent } from './models/file-upload-change-event';
import { FilesPointerEvent } from './types/files-upload-types';
import { FileUploadDocumentInterface } from './models/file-upload-document-interface';
import { NotificationService } from '../../base/services/notification/notification-service';
import { DisplayState } from '../../shared/enums/signaturit/signaturit-enums';
import { CdkDragDrop, moveItemInArray } from '@angular/cdk/drag-drop';

@Component({
  selector: 'filesupload',
  templateUrl: './files-upload.component.html',
  styleUrls: ['./files-upload.component.scss'],
})
export class FilesUploadComponent implements OnInit, AfterViewInit, OnDestroy, OnChanges {
  /**
   * Object the header string of the component
   */
  @Input() header: string;

  /**
   * Object the help text string of the mat-tooltip
   */
  @Input() helpText: string;

  /**
   * Object the button text for delete all uploaded files
   */
  @Input() deleteAll: string;

  /**
   * Object for setting the max number of files
   */
  @Input() maxFiles!: number;

  /**
   * Object for setting the choose label string
   */
  @Input() chooseLabel: string;

  /**
   * Object for setting the cancel label string
   */
  @Input() cancelLabel: string;

  /**
   * Object for setting the accept label string
   */
  @Input() accept: string;

  @Input() lite = false;

  @Input() type: string;

  @Input() finish: boolean;

  @Input() create: boolean;

  @Input() docPrevious: string[] = [];

  @Input() disableButtons: boolean = false;

  @Input() documentsToBlcok: any;

  /**
   * Boolean for setting the aditional documents
   */
  @Input() disableAditionalDocuments: boolean;

  @Input() selectedFiles: File[];


  /**
 * Object for setting the max size per file on component
*/
  @Input() maxFileSize: number;

  /**
   * Object for setting the max size of all documents together
  */
  @Input() docSizeTotal: number;

  /**
   * Returns the event OnUpload
   */
  @Output() onUpload: EventEmitter<any> = new EventEmitter<any>();

  /**
   * Returns the event onError
   */
  @Output() onError: EventEmitter<any> = new EventEmitter<any>();

  /**
   * Returns the event onClear
   */
  @Output() onClear: EventEmitter<any> = new EventEmitter<any>();

  /**
   * Returns the event onRemove
   */
  @Output() onRemove: EventEmitter<any> = new EventEmitter<any>();

  /**
   * Returns the event onSelect
   */
  @Output() onSelect: EventEmitter<any> = new EventEmitter<any>();

  /**
 * Drag and drop documents
 */
  @Output() dragEventDocs: EventEmitter<any> = new EventEmitter<any>();
  /**
   * Returns the event onSelect
   */
  @Output() onChange = new EventEmitter<FilesUploadChangeEvent | FilesPointerEvent>();

  /**
   * Returns the event uploadHandler
   */
  @Output() uploadHandler: EventEmitter<any>;

  /**
   * Object for the ElementRef of fileinput
   */
  @ViewChild('fileInput') fileInput: ElementRef;

  /**
   * Object for ElementRef of contenedor
   */
  @ViewChild('contenedor') contenedor: ElementRef;

  multiple: boolean = this.maxFiles > 1;

  /**
   * Boolean for setting the errorsize
   */
  errorsize: boolean;

  /**
   * Object for storing the files uploaded
   */
  files: File[] = [];

  filesNew: FileUploadDocumentInterface[];

  /**
   * Boolean for block an duplicate event on IE
   */
  duplicateIEEvent = false;

  /**
   * Boolean for auto attribute
   */
  auto: boolean;

  /**
   * Object for the size of the file
   */
  size = 0;

  /**
   * String for the error message
   */
  error: string = null;

  /**
   * Object for setting the error messages
   */
  errorParam = '';

  /**
   * Boolean for show the application load screen or not
   */
  loading = false;

  _transParam = false;

  /*
   * Boolean that checks if there's a circuit type selected.
   */
  disableUpload = false;

  /*
   * Boolean to show or hide the mat-tooltip
   */
  hasTooltip = true;

  /*
   * Array of docs
   */
  docsDrive = [];

  sizeFilesUpload: number = 0;

  isValid: boolean = true;

  isPrimary: boolean = true;

  minPage: number = 1;

  errorMessage: string;

  constructor(
    private renderer: Renderer2,
    private _sanitiz: DomSanitizer,
    public _translate: TranslateService,
    public dialog: MatDialog,
    public _message: MessageService,
    public sizeAll: SizeAllDocsService,
    private filesUpload: FilesUploadService,
    private _notification: NotificationService
  ) {
    this.errorsize = true;
    TranslateService.initTranslateSubscription(this);
  }

  ngOnInit(): void {
    this.error = null;
    this.filesNew = [];
    if (!this.helpText) {
      this.hasTooltip = false;
    }
    if (!document.getElementById('drive')) {
      const SCRIPT_PATH_DRIVE = 'https://apis.google.com/js/api.js';
      const SCRIPT_PATH_DROPBOX = 'https://www.dropbox.com/static/api/2/dropins.js';
      this.loadScript(SCRIPT_PATH_DRIVE);
      this.loadScript(SCRIPT_PATH_DROPBOX);
    }

    if (this.finish) {
      const containerUploader = document.getElementById('contentUpload');
      containerUploader.style.backgroundColor = 'White';
    }
  }

  ngOnChanges(): void {
    this.onFileSelect(this.selectedFiles);
  }

  ngOnDestroy(): void {
    this.sizeAll.totalSize = 0;
  }

  ngAfterViewInit(): void {
    this.validatorCreateCircuit();
    this.listenChangeReceiver();
  }

  /**
   * The function checks if files are uploaded
   */
  hasFiles(): boolean {
    return this.files && this.files.length > 0;
  }

  onFocus(): void { }

  onBlur(): void { }

  /**
   * The function return the size on Bytes
   * @param {number} bytes The size to be formated
   */
  formatSize(bytes: number): string {
    if (bytes == 0) {
      return '0 B';
    }
    const k = 1024,
      dm = 3,
      sizes = ['B', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'],
      i = Math.floor(Math.log(bytes) / Math.log(k));

    return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
  }

  /**
   * The function triggers on file selection
   * @param {event} event The event triggered with action
   */
  onFileSelect(event: any, type?: any, doc?: any): void {
    if (!event || (event.type !== 'drop' && this.isIE11() && this.duplicateIEEvent)) {
      this.duplicateIEEvent = false;
      return;
    }
    this.loading = true;
    let files: any[] = event.dataTransfer ? event.dataTransfer.files : type === 'external' ? event : event.target.files;
    if (!files.length) {
      files = doc;
    }
    const filesOK: any[] = [];
    if (!this.getErrors(files)) {
      if (event.dataTransfer) {
        for (let i = 0; i < event.dataTransfer.files.length; i++) {
          this.countSizeUpload(event.dataTransfer.files[i].size);
          this.sizeAll.countSizeDocs(event.dataTransfer.files[i].size);
        }
      } else {
        if (event.target?.files) {
          for (let i = 0; i < event.target.files.length; i++) {
            this.countSizeUpload(event.target.files[i].size);
            this.sizeAll.countSizeDocs(event.target.files[i].size);
          }
        } else {
          for (let i = 0; i < event.length; i++) {
            this.countSizeUpload(event[i].size);
            this.sizeAll.countSizeDocs(event[i].size);
          }
        }
      }
      if (this.sizeAll.totalSize > 40000000) {
        this._notification.setText(this._translate.instant('maxSize_40'))
        this._notification.activeNotif(DisplayState.ERROR);
        if (event.dataTransfer) {
          for (let i = 0; i < event.dataTransfer.files.length; i++) {
            this.sizeAll.restSizeDocs(event.dataTransfer.files[i].size);
            this.restSizeDocs(event.dataTransfer.files[i].size);
          }
        } else {
          if (event.target?.files) {
            for (let i = 0; i < event.target.files.length; i++) {
              this.sizeAll.restSizeDocs(event.target.files[i].size);
              this.restSizeDocs(event.target.files[i].size);
            }
          }
          else {
            for (let i = 0; i < event.length; i++) {
              this.restSizeDocs(event[i].size)
              this.sizeAll.restSizeDocs(event[i].size);
            }
          }
        }
        this.loading = false;
        return;
      }
      for (let i = 0; i < files?.length; i++) {
        if (this.isImage(files[i])) {
          files[i].objectURL = this._sanitiz.bypassSecurityTrustUrl(window.URL.createObjectURL(files[i]));
        }
        this.files.push(files[i]);
        filesOK.push(files[i]);
      }
      this.loading = false;
      this.onSelect.emit({ originalEvent: event, files: filesOK });
      this.processFiles(filesOK);

      if (this.hasFiles() && this.auto) {
        this.upload();
      }

      if (event.type !== 'drop' && this.isIE11()) {
        this.clearIEInput();
      } else {
        this.clearInputElement();
      }
    } else {
      this.loading = false;
    }
  }

  processFiles(files: File[]): void {
    if (!files?.length) {
      return;
    }
    let counter = 0;
    if (!this.isMultiple()) {
      this.filesNew = [];
    }
    for (const file of files) {
      const extension: string[] | string = file.name.split('.').pop().toLowerCase();
      const f = {
        name: file.name,
        content: null,
        extension: extension,
      };
      const blob = Utils.blobIE(file, 'application/' + extension + ';charset=utf-8', extension);
      const reader: FileReader = new FileReader();
      reader.readAsDataURL(blob);
      reader.onloadend = () => {
        f.content = (reader.result as string).split(',')[1];
        this.filesNew.push(f);
        counter++;
        if (counter === files.length) {
          const changeEvent = {
            type: 1,
            files: this.filesNew,
          };
          this.onChange.emit(changeEvent);
        }
      };
    }
  }

  /**
   * The function get the errors of the uploaded files
   * @param {any} files The files uploaded
   */
  getErrors(files: any[]): boolean {
    this.error = null;
    this.errorParam = '';
    let size = 0;

    // CHECK NUMBER OF FILES
    if (this.maxFiles && this.files?.length + files?.length > this.maxFiles) {
      this.error = 'maxFilesNumber';
      this.errorParam = this.maxFiles?.toString();

      return true;
    }

    // CHECK TOTAL FILES SIZE
    for (let i = 0; i < files?.length && !this.error; i++) {
      const file = files[i];
      let fileExt = file.name.split('.');
      fileExt = fileExt[fileExt.length - 1].toUpperCase();

      if (this.accept && this.accept.toUpperCase().indexOf(fileExt) === -1) {
        this.error = 'extensions';
        this.errorParam = this.accept;

        return true;
      }

      for (let index = 0; index < this.files?.length; index++) {
        if (this.files[index].name === file.name) {
          this.error = 'duplicate';
          this.errorParam = this.files[index].name;

          return true;
        }
      }
      if (this.finish) {
        for (const doc of this.docPrevious) {
          if (doc === file.name) {
            this.error = 'duplicate';
            this.errorParam = file.name;

            return true;
          }
        }
      }
    }

    // if(this.finish){
    //   this.files.forEach(file => {
    //     size += file.size;
    //   })

    //     if (this.docSizeTotal && size > this.docSizeTotal) {

    //       this.errorMessage = `${this._translate.instant('filesupload_error_maxFilesSize')} ${(this.maxFileSize / 1048576).toFixed(2)}MB`

    //       this.error = 'maxFilesSize';

    //       // this.errorParam = [{ '$$$': (this.docSizeTotal / 1048576).toFixed(2) }];

    //       return true;
    //     }
    // }
    return false;
  }

  /**
   * The function checks if file is selected
   * @param {file} file The file for check
   */
  isFileSelected(file: any): boolean {
    for (let i = 0; i < this.files.length; i++) {
      const sFile = this.files[i];
      if (sFile.name + sFile.type + sFile.size === file.name + file.type + file.size) {
        return true;
      }
    }

    return false;
  }

  /**
   * The function checks if file is image
   * @param {file} file The file for checking
   */
  isImage(file: any): boolean {
    return /^image\//.test(file.type);
  }

  /**
   * The function uploads an image
   */
  upload(): void {
    this.uploadHandler.emit({
      files: this.files,
    });
  }

  /**
   * The function clears the view
   */
  clear(): void {
    if (!this.documentsToBlcok?.length) {
      this.files.forEach((file) => {
        this.sizeAll.restSizeDocs(file.size);
        this.restSizeDocs(file.size);
      });
      this.files = [];
      this.error = null;
      this.size = 0;
      this.onClear.emit();
      const event = {
        type: 2,
      };
      this.onChange.emit(event);
      this.clearInputElement();
    } else {
      this.files.forEach((file, index) => {
        if (this.canRemoveDocument(index)) {
          this.sizeAll.restSizeDocs(file.size);
          this.restSizeDocs(file.size);
          this.clearInputElement();
          this.size -= file.size;
          this.onRemove.emit({ originalEvent: event, file: this.files[index], fileIndex: index });
          this.files.splice(index, 1);
        }
      });
    }
  }

  /**
   * The function removes an specific file
   * @param {event} event The event generated
   * @param {number} index The index of the file to remove
   */
  remove(event: FilesPointerEvent, index: number): void {
    this.sizeAll.restSizeDocs(this.files[index].size);
    this.restSizeDocs(this.files[index].size);
    this.clearInputElement();
    this.size -= this.files[index].size;
    this.onRemove.emit({ originalEvent: event, files: [this.files[index]], fileIndex: index });
    this.files.splice(index, 1);
    event.files = this.files;
    this.onChange.emit(event);
  }

  canRemoveDocument(index: number): boolean {
    if (this.documentsToBlcok?.length) {
      const element = this.documentsToBlcok.find((res) => res.fileNameWithExtension === this.files[index].name);

      if (element) {
        return false;
      }
    }

    return true;
  }

  /**
   * The function clears the upload input
   */
  clearInputElement(): void {
    if (this.fileInput && this.fileInput.nativeElement) {
      this.fileInput.nativeElement.value = '';
    }
  }

  /**
   * The function clears the input for IE
   */
  clearIEInput(): void {
    if (this.fileInput && this.fileInput.nativeElement) {
      this.duplicateIEEvent = true; // IE11 fix to prevent onFileChange trigger again
      this.fileInput.nativeElement.value = '';
    }
  }

  onDragEnter(): void { }

  /**
   * The function register the event onDragLeave
   * @param {event} event The event generated by the action
   */
  onDragLeave(event: any): void {
    this.renderer.removeClass(this.contenedor.nativeElement, 'drogover');
    event.stopPropagation();
    event.preventDefault();
  }

  /**
   * The function register the event onDrop
   * @param {event} event The event generated by the action
   */
  onDrop(event: any): void {
    this.renderer.removeClass(this.contenedor.nativeElement, 'drogover');
    event.stopPropagation();
    event.preventDefault();
    const allowDrop = this.isMultiple() || (this.files && this.files.length === 1);
    if (allowDrop && !this.disableUpload) {
      if (this.type === FileUploadType.PRIMARY) {
        this.minPage = this.filesUpload.getMinPage();
        let index = 0;
        this.filesUpload.resetValidation();
        for (const file of event.dataTransfer.files) {
          this.filesUpload.validateFile(file, 1, event.dataTransfer.files.length, index);
          index++;
        }
        this.onFileSelect(event);
        this.listenValidatorFile();
      } else {
        this.onFileSelect(event);
      }
    }
  }

  listenValidatorFile(): void {
    this.filesUpload.blockUpload.subscribe((event) => {
      this.isValid = false;
      if (event) {
        this.isValid = true;
      } else {
        this.isValid = false;
        this.clear();
      }
    });
  }

  listenChangeReceiver(): void {
    if (this.type === FileUploadType.PRIMARY) {
      this.filesUpload.changeReceivers.subscribe((event) => {
        if (event) {
          this.isValid = true;
        }
      });
    }
  }

  validatorCreateCircuit(): void {
    this.filesUpload.setCreate(this.create);
  }

  /**
   * The function register the event onDragOver
   * @param {event} event The event generated by the action
   */
  onDragOver(event: any): void {
    this.renderer.addClass(this.contenedor.nativeElement, 'drogover');
    event.stopPropagation();
    event.preventDefault();
  }

  /**
   * The function checks if the user is using IE11
   */
  isIE11(): boolean {
    return !!window['MSInputMethodContext'] && !!document['documentMode'];
  }

  /**
   * The function checks if the file to upload its an allowed type
   * @param {file} file The file for check
   */
  isFileTypeValid(file: any): boolean {
    const acceptableTypes = this.accept.split(',');
    for (let i = 0, acceptableTypes_1 = acceptableTypes; i < acceptableTypes_1.length; i++) {
      const type = acceptableTypes_1[i];
      const acceptable = this.isWildcard(type)
        ? this.getTypeClass(file.type) === this.getTypeClass(type)
        : file.type == type || this.getFileExtension(file).toLowerCase() === type.toLowerCase();
      if (acceptable) {
        return true;
      }
    }

    return false;
  }

  /**
   * The function obtains the file type from the file
   * @param {file} filetype The filetype to check
   */
  getTypeClass(fileType: string): string {
    return fileType.substring(0, fileType.indexOf('/'));
  }

  /**
   * The function check if the file type its a wildcard
   * @param {file} fileType The filetype to check
   */
  isWildcard(fileType: string | string[]): boolean {
    return fileType.indexOf('*') !== -1;
  }

  /**
   * The function obtains the extension from the file
   * @param {file} file The file to check
   */
  getFileExtension(file: any): string {
    return '.' + file.name.split('.').pop();
  }

  isMultiple(): boolean {
    return this.maxFiles > 1;
  }

  openDialog(): void {
    this.docsDrive = [];
    const data = {
      extensions: this.accept ?? '',
      type: this.type,
    };
    const dialogRef = this.dialog.open(FilesUploadDialogComponent, {
      width: '390px',
      data: data,
      disableClose: true,
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result[0]?.type === 'external') {
        for (let i = 0; i < result.length; i++) {
          const doc = result[i].doc;
          this.docsDrive.push(doc);
        }
        this.onFileSelect(this.docsDrive, 'external');
      } else if (result[0]?.type === 'drag') {
        this.onFileSelect(result[0].event, 'drag', result[0].doc);
      } else {
        if (result) {
          this.onFileSelect(result);
        } else {
          return;
        }
      }
    });
  }

  loadScript(url: string): void {
    const body = <HTMLScriptElement>document.body;
    const script = document.createElement('script');
    script.src = url;

    if (url.includes('dropbox')) {
      const APP_KEY = '3erj9xnj8ccqv7p';
      script.setAttribute('data-app-key', APP_KEY);
      script.id = 'dropboxjs';
      script.type = 'text/javascript';
    } else {
      script.id = 'drive';
    }
    body.appendChild(script);
  }

  countSizeUpload(value: number): void {
    this.sizeFilesUpload = this.sizeFilesUpload + value;
  }

  restSizeDocs(value: number): void {
    this.sizeFilesUpload = this.sizeFilesUpload - value;
  }

  dropDocs(event: CdkDragDrop<string[]>): void {
    moveItemInArray(this.files, event.previousIndex, event.currentIndex);
    this.dragEventDocs.emit(this.files)
  }

}
